// extracted by mini-css-extract-plugin
export default {"header":"style_header__YoeMJ","carousel":"style_carousel__mkwQU"};